var map = {
	"./icon-author.svg": 61626,
	"./icon-authorX.svg": 13966,
	"./icon-close.svg": 38777,
	"./icon-collect-x.svg": 42764,
	"./icon-collect.svg": 29427,
	"./icon-comment.svg": 58386,
	"./icon-gfans-bottom.svg": 94628,
	"./icon-gfans-check.svg": 21431,
	"./icon-gfans-checka.svg": 21876,
	"./icon-gfans-clear.svg": 47060,
	"./icon-gfans-cvd.svg": 19014,
	"./icon-gfans-cvda.svg": 70539,
	"./icon-gfans-fj.svg": 59061,
	"./icon-gfans-hj.svg": 70819,
	"./icon-gfans-imgNo.svg": 90891,
	"./icon-gfans-imgWg.svg": 32184,
	"./icon-gfans-more.svg": 76218,
	"./icon-gfans-more1.svg": 58167,
	"./icon-gfans-more2.svg": 3716,
	"./icon-gfans-refresh.svg": 41258,
	"./icon-gfans-select.svg": 22825,
	"./icon-gfans-tab-left.svg": 67080,
	"./icon-gfans-tab-right.svg": 52023,
	"./icon-gfans-vd.svg": 11699,
	"./icon-gfans-videoNo.svg": 25535,
	"./icon-gfans-videoWg.svg": 85244,
	"./icon-gfans-wj.svg": 52150,
	"./icon-hot-long.svg": 68455,
	"./icon-hot-new.svg": 8513,
	"./icon-hot.svg": 61356,
	"./icon-input.svg": 72849,
	"./icon-left.svg": 71848,
	"./icon-menu1-a.svg": 83205,
	"./icon-menu1-b.svg": 84070,
	"./icon-menu1.svg": 16080,
	"./icon-menu2-a.svg": 61889,
	"./icon-menu2-b.svg": 67245,
	"./icon-menu2.svg": 27600,
	"./icon-model-close.svg": 32489,
	"./icon-notes.svg": 2142,
	"./icon-release.svg": 39234,
	"./icon-releaseBt-add.svg": 52854,
	"./icon-releaseBt.svg": 200,
	"./icon-right.svg": 55191,
	"./icon-search.svg": 78331,
	"./icon-share.svg": 72576,
	"./icon-switch-dark.svg": 30864,
	"./icon-switch-light.svg": 14336,
	"./icon-switch-system.svg": 35567,
	"./icon-top.svg": 36804,
	"./icon-up-x.svg": 15839,
	"./icon-up.svg": 17160,
	"./icon-video-stop.svg": 5025,
	"./icon-yes.svg": 25784
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;